"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var Footer = function Footer(_ref) {
  var children = _ref.children,
    link = _ref.link;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, children, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary mt-4"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, t('menu.help'))));
};
var _default = exports["default"] = Footer;
//# sourceMappingURL=Footer.js.map